import { h } from 'preact'
import styles from './side-explainer.module.css'

export const SideExplainer = ({ sideOne, sideTwo }) => {
  return (
    <div className={styles.sideExplainer}>
      <div className={styles.leftBorder}>
        <h3 dangerouslySetInnerHTML={{ __html: sideOne.title }}></h3>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: sideOne.text }}></div>
      </div>
      <div className={styles.rightBorder}>
        <h3 dangerouslySetInnerHTML={{ __html: sideTwo.title }}></h3>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: sideTwo.text }}></div>
      </div>
    </div>
  )
}
